import * as React from 'react';
import { BemMethod, createBem } from '@om-fe/utils';

interface MatchListSkeletonDefaultPublicProps {
    readonly numberOfAnimationNodes: number;
}

type MatchListSkeletonPublicProps = Partial<MatchListSkeletonDefaultPublicProps>;

type MatchListSkeletonProps = MatchListSkeletonPublicProps &
    MatchListSkeletonDefaultPublicProps;

export const DEFAULT_NUMBER_OF_ANIMATIONS: number = 4;

const bem: BemMethod = createBem('MatchListSkeleton');

export default class MatchListSkeleton extends React.PureComponent<MatchListSkeletonProps> {

    static defaultProps: MatchListSkeletonDefaultPublicProps = {
        numberOfAnimationNodes: DEFAULT_NUMBER_OF_ANIMATIONS,
    };

    getSkeletonAnimationNode(numberOfAnimatedItems: number) {
        const animatedItems: React.ReactNode[] = [];

        for (let i = 0; i < numberOfAnimatedItems; i++) {
            animatedItems.push(
                <span className={bem('Item')} key={i}>
                    <span className={bem('Section', 'Info')}>
                        <span className={bem('Text')} />
                        <span className={bem('Text')} />
                        <span className={bem('LessText')} />
                    </span>
                    <span className={bem('Section', 'Odds')}>
                        <span className={bem('Button')} />
                        <span className={bem('Button')} />
                        <span className={bem('Button')} />
                    </span>
                </span>,
            );
        }

        return animatedItems;
    }

    render() {
        return (
            <div className={bem()}>
                {this.getSkeletonAnimationNode(this.props.numberOfAnimationNodes)}
            </div>
        );
    }
}
